import { axiosInstance } from "../../axios/axiosInstance";
import { ADMIN_API_URL, getDefaultHeaders } from "../../config";

const authHeaders = (extra = {}) => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
    ...extra,
  };
};

export const getTemplates = (params = {}) =>
  axiosInstance.get(`${ADMIN_API_URL}/template`, {
    headers: authHeaders(),
    params,
  });

export const removeTemplate = (templateId) =>
  axiosInstance.delete(`${ADMIN_API_URL}/template/${templateId}`, {
    headers: authHeaders(),
  });

export const getTemplatePartyData = (template_id) =>
  axiosInstance.get(`${ADMIN_API_URL}/template/get/party_data`, {
    headers: authHeaders(),
    params: { template_id },
  });

export const updateTemplateRecipientsRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/template/update/recipient`, payload, {
    headers: authHeaders(),
  });

export const updateTemplatePreferencesRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/template/update/preferences`, payload, {
    headers: authHeaders(),
  });

export const updateTemplatePartiesRequest = (payload) =>
  axiosInstance.post(`${ADMIN_API_URL}/template/update/tools`, payload, {
    headers: authHeaders(),
  });

export const getTemplateEventLog = (template_id) =>
  axiosInstance.post(
    `${ADMIN_API_URL}/template/get_event_log`,
    { template_id },
    { headers: authHeaders() },
  );
